import { Divider } from "@material-ui/core";
import { DescriptionOutlined } from "@material-ui/icons";
import { Box, Container, Grid } from "@mui/material";
import ExcelLogo from "assets/img/excel-logo.png";
import axios from "axios";
import {
  AutoCompleteComponent,
  BalanceCard,
  CustomTable,
  ModalError,
  ModalSuccess,
  MonthYearRangePicker,
  Page,
  PrimaryButton,
  SearchTextInput,
  SwitchInput,
} from "components";
import { HeaderTitle } from "layouts";
import { getTotalPage } from "lib";
import { debounce } from "lodash";
import moment from "moment";
import { useCallback, useEffect, useRef, useState } from "react";
import { useHistory } from "react-router";
import { useLocation } from "react-router-dom";
import { hardBaseUrl } from "services/urlConstant";
import { globalStyles } from "styles";
import { getErrors } from "utils";
import { columnTableReport } from "./Components/ConstanstReport";

function Report() {
  const classes = globalStyles();
  const history = useHistory();
  const location = useLocation();
  const isFirstLoad = useRef(true);
  const token = localStorage.getItem("token");
  const headers = {
    Authorization: `Bearer ${token}`,
  };
  const urlParams = new URLSearchParams(location.search);
  const parmasDspId = urlParams.get("dsp_id");
  const paramsSearch = urlParams.get("search");
  const paramsPage = urlParams.get("page");
  const paramsSize = urlParams.get("size");
  const paramsStartDate = urlParams.get("startDate");
  const paramsEndDate = urlParams.get("endDate");

  const [loadingPage, setLoadingPage] = useState(true);
  const [optionDsp, setOptionDsp] = useState([]);
  const [dataTable, setDataTable] = useState([]);
  const [queryParams, setQueryParams] = useState({
    page: Number(paramsPage) || 1,
    size: Number(paramsSize) || 10,
    search: paramsSearch || "",
    dsp_id: Number(parmasDspId) || "",
    startDate: paramsStartDate
      ? formatGetPeriodParams(paramsStartDate)
      : moment().subtract(1, "months"),
    endDate: paramsEndDate ? formatGetPeriodParams(paramsEndDate) : moment(),
  });
  const [tableTotalPage, setTableTotalPage] = useState(1);
  const [loadingButton, setLoadingButton] = useState({
    pdf: false,
    excel: false,
  });
  const { startDate, endDate, ...otherParams } = queryParams;
  const [dataSummary, setDataSummary] = useState([
    { name: "Total Income", value: 0 },
    { name: "Total Composer Revenue", value: 0 },
    { name: "Total Publisher Revenue", value: 0 },
    { name: "Grand Total", value: 0 },
  ]);
  const [isPublisherReport, setIsPublisherReport] = useState(false);

  const handleChangePageParams = (value, key) => {
    urlParams.set(key, value);
    history.replace({
      pathname: location.pathname,
      search: urlParams.toString(),
    });
  };

  const handleChangeQueryParams = (value, key) => {
    setQueryParams(currentState => ({
      ...currentState,
      ...(key !== "page" && { page: 1 }),
      [key]: value,
    }));

    handleChangePageParams(value, key);
    if (key !== "page") {
      handleChangePageParams(1, "page");
    }
  };
  const handleChangeStartDate = date => {
    handleChangeQueryParams(date, "startDate");
    handleChangePageParams(formatSetPeriodParams(date), "startDate");
  };
  const handleChangeEndDate = date => {
    handleChangeQueryParams(date, "endDate");
    handleChangePageParams(formatSetPeriodParams(date), "endDate");
  };

  const getOptionDsp = async () => {
    try {
      const res = await axios.get(`${hardBaseUrl}/master/all-client`, {
        headers,
      });
      const { data } = res?.data;
      const newOptions = data?.map(item => ({
        ...item,
        id: item?.dsp_id,
        label: item?.dsp_name,
      }));
      setOptionDsp(newOptions);
    } catch (error) {
      ModalError(getErrors(error?.response));
    }
  };
  const getDataSummary = async () => {
    try {
      const res = await axios.get(`${hardBaseUrl}/report/card`, {
        headers,
        params: {
          dsp_id: queryParams?.dsp_id,
          search: queryParams?.search,
          start_month: formatParamsMonth(startDate),
          end_month: formatParamsMonth(endDate),
          year: formatParamsYear(startDate),
        },
      });
      const typeColorMap = {
        "Total Income": { type: "income", color: "#54B371" },
        "Total Composer Revenue": { type: "composer", color: "#4991F2" },
        "Total Publisher Revenue": { type: "publisher", color: "#F6C962" },
        "Grand Total": { type: "total", color: "#DE5242" },
      };
      const order = ["income", "composer", "publisher", "total"];
      const modifiedData = Object.values(res?.data?.data)
        .map(item => ({
          ...item,
          type: typeColorMap[item?.name]?.type || "unknown",
          backgroundColor: typeColorMap[item?.name]?.color || "#111827",
        }))
        .sort((a, b) => order.indexOf(a.type) - order.indexOf(b.type));
      setDataSummary(modifiedData);
    } catch (error) {
      ModalError(getErrors(error?.response));
    }
  };
  const getDataTable = async () => {
    try {
      const res = await axios.get(`${hardBaseUrl}/report`, {
        headers,
        params: {
          ...otherParams,
          start_month: formatParamsMonth(startDate),
          end_month: formatParamsMonth(endDate),
          year: formatParamsYear(startDate),
        },
      });
      const { data, meta } = res?.data;
      setDataTable(data || []);
      const pageCount = getTotalPage(meta?.total, queryParams?.size);
      setTableTotalPage(pageCount || 1);
    } catch (error) {
      ModalError(getErrors(error?.response));
    }
  };
  const debounceDataTable = useCallback(
    debounce(async () => {
      setLoadingPage(true);
      await getDataTable();
      setLoadingPage(false);
    }, 500),
    [queryParams]
  );
  const getDownloadReport = async type => {
    const formData = new FormData();
    const { endDate, startDate, dsp_id } = queryParams;
    const params = {
      start_month: startDate?.month() + 1,
      end_month: endDate?.month() + 1,
      year: startDate?.year(),
      type: type,
      dsp_id,
      is_publisher_report: isPublisherReport,
    };
    Object.entries(params).forEach(([key, value]) => {
      if (value !== undefined && value !== null) {
        formData.append(key, value);
      }
    });
    setLoadingButton(prev => ({
      ...prev,
      [type]: true,
    }));
    try {
      const res = await axios.post(`${hardBaseUrl}/report/export`, formData, {
        headers,
      });
      ModalSuccess(res.data?.message).then(() =>
        history.push("/admin/download-monitoring")
      );
    } catch (error) {
      ModalError(getErrors(error?.response));
    } finally {
      setLoadingButton({ pdf: false, excel: false });
    }
  };
  const fetchData = async () => {
    setLoadingPage(true);
    const promises = [getDataSummary(), getDataTable()];
    if (isFirstLoad.current) {
      promises.push(getOptionDsp());
    }

    try {
      await Promise.all(promises);
    } catch (error) {
      ModalError(error, "Error fetching data");
    } finally {
      setLoadingPage(false);
      isFirstLoad.current = false;
    }
  };

  useEffect(() => {
    const isSearching = Boolean(queryParams?.search);
    if (isSearching) {
      debounceDataTable();
      return () => {
        debounceDataTable.cancel();
      };
    } else {
      fetchData();
    }
  }, [queryParams, debounceDataTable]);

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <Page className={classes.root} title="Report V2">
      <Container maxWidth={false}>
        <HeaderTitle title="Report V2" breadcrumbData={breadcrumbData} />
        <Divider className={classes.divider} />
        <Grid container columnSpacing={1} mb={2}>
          <Grid item>
            <AutoCompleteComponent
              label="DSP"
              placeholder="All DSP"
              options={optionDsp}
              value={
                optionDsp.find(option => option.id === queryParams?.dsp_id) ||
                null
              }
              onChange={e => handleChangeQueryParams(e, "dsp_id")}
              size="small"
              width={300}
              disabled={loadingPage}
            />
          </Grid>
          <Grid item>
            <MonthYearRangePicker
              label="Period"
              startDate={startDate}
              handleChangeStartDate={handleChangeStartDate}
              endDate={endDate}
              handleChangeEndDate={handleChangeEndDate}
              syncYear
              width={250}
              disabled={loadingPage}
            />
          </Grid>
        </Grid>
        <Box display="flex" overflow="auto" columnGap={2}>
          {dataSummary?.map((item, index) => (
            <Box flexShrink={0} key={index}>
              <BalanceCard
                title={item?.name}
                value={item?.value}
                subTitle={`${item?.total_composer} Composer`}
                backgroundColor={item?.backgroundColor}
                loading={loadingPage}
                titleColor="white"
              />
            </Box>
          ))}
        </Box>
        <Grid container justifyContent="space-between" my={2}>
          <Grid item>
            <SearchTextInput
              placeholder="Search"
              value={queryParams?.search}
              onChange={e =>
                handleChangeQueryParams(e?.target?.value, "search")
              }
              disabled={loadingPage}
            />
          </Grid>
          <Grid item>
            <Grid
              container
              columnSpacing={1}
              justifyContent="flex-end"
              alignItems="center"
            >
              <Grid item>
                <SwitchInput
                  label={`${
                    isPublisherReport ? "Publisher" : "Composer"
                  } Report`}
                  checked={isPublisherReport}
                  onChange={e => setIsPublisherReport(e?.target?.checked)}
                  disabled={loadingPage}
                />
              </Grid>
              <Grid item>
                <PrimaryButton
                  height={40}
                  label="Download as PDF"
                  onClick={() => getDownloadReport("pdf")}
                  disabled={loadingButton?.pdf || loadingPage}
                  loading={loadingButton?.pdf}
                  startIcon={<DescriptionOutlined />}
                />
              </Grid>
              <Grid item>
                <PrimaryButton
                  height={40}
                  label="Download as XLSX"
                  onClick={() => getDownloadReport("excel")}
                  disabled={loadingButton?.excel || loadingPage}
                  loading={loadingButton?.excel}
                  startIcon={<img src={ExcelLogo} alt="logo" />}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <CustomTable
          isLoading={loadingPage}
          columnTable={columnTableReport({ isDetail: false })}
          data={dataTable}
          page={queryParams?.page}
          pageSize={queryParams?.size}
          pageCount={tableTotalPage}
          handleChangePage={(_, page) => handleChangeQueryParams(page, "page")}
          handleChangePageSize={e =>
            handleChangeQueryParams(e?.target?.value, "size")
          }
          isHaveAction
          renderAction={item => (
            <PrimaryButton
              width={100}
              label="See Details"
              onClick={() =>
                history.push({
                  pathname: `/admin/reports/${item.composer_id}`,
                  state: {
                    startDate: formatSetPeriodParams(startDate),
                    endDate: formatSetPeriodParams(endDate),
                    dsp_id: queryParams?.dsp_id,
                  },
                })
              }
              size="small"
            />
          )}
        />
      </Container>
    </Page>
  );
}

const formatParamsMonth = date => date.format("M");
const formatParamsYear = date => date.format("YYYY");
const formatGetPeriodParams = date => moment(date, "M-YYYY");
const formatSetPeriodParams = date => moment(date).format("M-YYYY");

const breadcrumbData = [
  {
    label: "Home",
    link: "/admin/dashboard",
  },
  {
    label: "Report V2",
    active: true,
  },
];

export default Report;
